<template>
    <vx-action-icon
        :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'"
        class="mr-4"
        @click="goBack"
    />
</template>

<script>
export default {
    name: 'vx-back-button',
    props: {
        backAction: {
            type: Function
        }
    },
    methods: {
        goBack() {
            if (this.backAction) {
                this.backAction()
                return
            }
            this.$router.go(-1)
        }
    }
}
</script>
